export default (() => {

  const items = document.querySelectorAll('.component-career-pathway__item');

  function update(){
    for (let i=0; i<items.length - 1; i++){
      const item = items[i];
      const nextItem = items[i+1];

      const course = item.querySelector('.component-career-pathway__course');
      const nextCourse = nextItem.querySelector('.component-career-pathway__course');
      const arrowLine = item.querySelector('.arrow-line');
      const arrow = course.querySelector('svg');

      if(!arrowLine) return;

      const courseRect = course.getBoundingClientRect();
      const nextCourseRect = nextCourse.getBoundingClientRect();
  
      const y = nextCourseRect.top - courseRect.bottom - 7; 

      $(arrowLine).css('height', y + 'px');
      $(arrow).css('bottom', (-y) + 'px')
    }
  }

  window.addEventListener('resize', update);

  $(function(){
    update()
  })


  // Because of how the mobile course page has been designed, where you click first to then reveal the
  // subsection content, this is messing with getBoundingClientRect because the elements are not
  // visible on page load.
  // Use Intersection observer to know when we can update()
  const root = document.querySelector('.component-career-pathway')
  if(root){
    const bounds = root.getBoundingClientRect();
    if(!bounds.width || !bounds.height){      
      const observer = new IntersectionObserver((entries, observer) => {
        const bounds = root.getBoundingClientRect();
        if(bounds.width && bounds.height){
          update();
          observer.unobserve(root);
        }                
      });
      observer.observe(root);
    }
  }  

  

})();